import React from "react";
import { Grid } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { FormSelect } from "../../../../components";
import { FORM_CONSTANTS, RULE_TYPE_OPTIONS } from "../SelectRules.constants";

const RuleTypeSelector = ({
  triggerType = "RULE",
}: {
  triggerType?: string;
}) => {
  const { control } = useFormContext();

  const API_RULE_TYPES = [
    FORM_CONSTANTS.RULE_TYPES.ASSIGNED_AUDIENCE,
    FORM_CONSTANTS.RULE_TYPES.CLEANED_CUSTOMER,
  ];

  const filteredOptions =
    triggerType === "API"
      ? RULE_TYPE_OPTIONS.filter((opt) => API_RULE_TYPES.includes(opt.value))
      : RULE_TYPE_OPTIONS.filter(
          (opt) => opt.value !== FORM_CONSTANTS.RULE_TYPES.CLEANED_CUSTOMER
        );

  return (
    <Grid item xs={12}>
      <Controller
        name="ruleType"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <FormSelect
            field={field}
            label="Rule Type"
            placeholder="Select activity type"
            options={filteredOptions}
          />
        )}
      />
    </Grid>
  );
};

export default RuleTypeSelector;
